import React from 'react'
import type { ThreadHeaderProps } from 'stream-chat-react'
import { useChannelStateContext, useChatContext } from 'stream-chat-react'
import { AppAvatar } from 'components/Common/AppAvatar/AppAvatar.component'
import { getInitials } from 'components/Chat/helper'
import { isGroupChannel } from 'components/Chat/utils/channelHelpers'
import './MessagingThread.css'
import { CloseThreadIcon } from '../../assets'

const MessagingThreadHeader = ({ closeThread, thread }: ThreadHeaderProps) => {
  const { channel } = useChannelStateContext()
  const { client } = useChatContext()

  const members = Object.values(channel.state.members || {}).filter(
    (member) => member.user?.id !== client?.user?.id
  )

  const getReplyCount = () => {
    if (!thread?.reply_count) return ''
    if (thread.reply_count === 1) return '1 reply'
    return `${thread.reply_count} Replies`
  }

  const renderChannelIcon = () => {
    if (isGroupChannel(channel)) {
      return (
        <div className="w-10 h-10 bg-app-grey-40 rounded-full flex items-center justify-center overflow-hidden mr-3">
          {channel.data?.image ? (
            <img
              src={channel.data.image as string}
              alt="Group icon"
              className="w-full h-full object-cover rounded-full"
            />
          ) : (
            <svg
              className="w-5 h-5 text-app-grey-70"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
              />
            </svg>
          )}
        </div>
      )
    }

    return (
      <div className="mr-3">
        <AppAvatar
          size="md"
          type="mixed"
          shape="Rounded"
          text={getInitials({
            firstName: members[0]?.user?.firstName as string,
            lastName: members[0]?.user?.lastName as string,
          })}
        />
      </div>
    )
  }

  return (
    <div className="custom-thread-header">
      <div className="custom-thread-header__left">
        {renderChannelIcon()}
        <div>
          <p className="custom-thread-header__left-title">Thread</p>
          <p className="custom-thread-header__left-count">{getReplyCount()}</p>
        </div>
      </div>
      <CloseThreadIcon closeThread={closeThread} />
    </div>
  )
}

export default MessagingThreadHeader
